<div class="select-case-modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
  <div class="modal-header">
    <div class="header-text col col-12">
      <h2 class="h2 modal-title" tabindex="-1">{{ 'case-select-modal.title' | translate }}</h2>
      <p>{{ 'case-select-modal.sub-title' | translate }}</p>
    </div>
    <button
      mat-icon-button
      (click)="onCloseClick()"
      class="close-button"
      [attr.aria-label]="'alt-for-img.close-window' | translate "
    >
    <mat-icon svgIcon="close_custom_icon" class="custom-icon" ></mat-icon>
    </button>
  </div>

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (form.get('case')?.touched && form.get('case')?.hasError('required')) {
      <mat-error >
        {{ 'case-select-modal.validation-text' | translate }}
      </mat-error>
    }
    <mat-form-field class="case-select" appearance="outline">
      <mat-label>{{ 'case-select-modal.placeholder' | translate }}</mat-label>
      <mat-select formControlName="case">
        @for (item of store.cases(); track item.caseIdHash ) {
          <mat-option [value]="item.caseIdHash">{{ 'currency' | translate: { amount: item.balance | number: '1.2-2' : 'fr-FR'} }} {{item.presentCreditorShortName }}</mat-option>
        } @empty {
          <mat-option>
            <debtor-panel-loading-spinner-select [isLoading]="store.isLoadingCases()"/>
            @if(!store.isLoadingCases() &&  store.cases().length === 0) {
              {{ 'no-data' | translate }}
            } 
          </mat-option> 
        }
      </mat-select>
    </mat-form-field>

    <button
      mat-flat-button
      class="btn-common submit-button"
      type="submit"
      [disabled]="form.invalid"
    >
    {{ 'case-select-modal.submit-btn' | translate }}
    </button>
  </form>
</div>